import { compactI18n, displayText, parseI18n } from '@src/i18n';

export const NAME_MAX_LENGTH = 100;
export const DESCRIPTION_MAX_LENGTH = 500;

// Select options of tags, labelled in the reference language, else in the first available one.
export const toTagOptions = (tags = []) => tags.map((tag) => ({ value: tag.id, label: displayText(parseI18n(tag.valeur)) }));

// Form values of a collection, or of a new one when `collection` is null. Every language of `languages`
// starts blank, so that showing an empty language and undoing an edit in it leaves the form clean.
export const toFormValues = (collection, tagsOptions = {}, languages = []) => {
    const tagIds = new Set(collection?.tagsIds ?? []);
    const selected = (tags) => toTagOptions((tags ?? []).filter((tag) => tagIds.has(tag.id)));
    const blank = Object.fromEntries(languages.map(({ label }) => [label, '']));

    return {
        name: { ...blank, ...parseI18n(collection?.name) },
        description: { ...blank, ...parseI18n(collection?.description) },
        tagsTypology: selected(tagsOptions.typology),
        tagsDomain: selected(tagsOptions.domain),
        tagsFamily: selected(tagsOptions.family),
    };
};

// Payload of PUT /collections/{id}. It holds no tests, which the server then leaves as they are: the page adds and
// removes them on their own. The tags the page does not edit (types other than those of `tagsOptions`) are kept as
// they are.
export const toPayload = (values, collection, tagsOptions = {}) => {
    const { tagsIds = [] } = collection ?? {};
    const editableIds = new Set(
        [...(tagsOptions.typology ?? []), ...(tagsOptions.domain ?? []), ...(tagsOptions.family ?? [])].map((tag) => tag.id),
    );
    const selectedIds = [...values.tagsTypology, ...values.tagsDomain, ...values.tagsFamily].map((option) => Number(option.value));

    return {
        name: JSON.stringify(compactI18n(values.name)),
        description: JSON.stringify(compactI18n(values.description)),
        tagsIds: [...new Set([...selectedIds, ...tagsIds.filter((id) => !editableIds.has(id))])],
    };
};

// Language codes whose name is empty, marked with a dot on their tab.
export const emptyLanguages = (names = {}, languages = []) =>
    languages.map(({ label }) => label).filter((label) => !(names[label] ?? '').trim());
